'use client'

import { Box, styled } from '@mui/material'

export const StyledCallout = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.primary.main,
  padding: theme.spacing(4),
  borderRadius: theme.spacing(1),
  a: {
    textDecoration: 'none',
    'button.MuiTypography-root': {
      marginBottom:  0
    }
  },


  '&.primary': {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  '&.tertiary': {
    backgroundColor: theme.palette.tertiary.main,
    color: 'white',
  },

  '.MuiTypography-root': {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },

  button: {
    display: 'flex',
    boxSizing: 'border-box',
    
    margin: '0 auto',
  },

  [theme.breakpoints.up('md')]: {
    maxWidth: '336px',
  },
}))
